var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currentcredit"},[_c('img',{attrs:{"src":require("../../assets/common/icon/mypoints-bg.png"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("当前积分："+_vm._s(_vm.userpointsmallcredit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-463c1869","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/personalcenter/usercredit.vue
// module id = null
// module chunks = 